import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';
import { courseDataDefault } from 'utils/valueDefault';

const apiUrl = `${API_URL}/course`;

export const ACTION_TYPES = {
  FETCH_COURSE_LIST: 'course/FETCH_COURSE_LIST',
  FETCH_COURSE_LIST2: 'course/FETCH_COURSE_LIST2',
  FETCH_COURSE_REQUEST: 'course/FETCH_COURSE_REQUEST',
  FETCH_COURSE: 'course/FETCH_COURSE',
  FETCH_COURSEBYID: 'FETCH_COURSEBYID',
  CREATE_COURSE: 'course/CREATE_COURSE',
  UPDATE_COURSE: 'course/UPDATE_COURSE',
  DELETE_COURSE: 'course/DELETE_COURSE',
  RESET: 'course/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [], //ent
  entities2: [],
  entitiesreq: [],
  entity: courseDataDefault, //defaultValue
  entity2: courseDataDefault,
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const courseReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_COURSE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_COURSE_LIST2):
    case REQUEST(ACTION_TYPES.FETCH_COURSE_REQUEST):
    case REQUEST(ACTION_TYPES.FETCH_COURSE):
    case REQUEST(ACTION_TYPES.FETCH_COURSEBYID):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_COURSE):
    case REQUEST(ACTION_TYPES.UPDATE_COURSE):
    case REQUEST(ACTION_TYPES.DELETE_COURSE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_COURSE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_COURSE_LIST2):
    case FAILURE(ACTION_TYPES.FETCH_COURSE_REQUEST):
    case FAILURE(ACTION_TYPES.FETCH_COURSE):
    case FAILURE(ACTION_TYPES.FETCH_COURSEBYID):
    case FAILURE(ACTION_TYPES.CREATE_COURSE):
    case FAILURE(ACTION_TYPES.UPDATE_COURSE):
    case FAILURE(ACTION_TYPES.DELETE_COURSE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload.response,
      };
    case SUCCESS(ACTION_TYPES.FETCH_COURSE_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_COURSE_REQUEST):
        let request = action.payload.data;
        return {
          ...state,
          loading: false,
          entitiesreq: request.content,
          pageable: {
            sort: {
              sorted: request.pageable.sort.sorted,
              unsorted: request.pageable.sort.unsorted,
              empty: request.pageable.sort.empty,
            },
            pageSize: request.pageable.page_size,
            pageNumber: request.pageable.page_number,
            offset: request.pageable.offset,
            paged: request.pageable.paged,
            unpaged: request.pageable.unpaged,
          },
          totalElements: request.total_elements,
          last: request.last,
          totalPages: request.total_pages,
          sort: request.sort,
          first: request.first,
          numberOfElements: request.number_of_elements,
          size: request.size,
          number: request.number,
          empty: request.empty,
        };
    case SUCCESS(ACTION_TYPES.FETCH_COURSE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_COURSE_LIST2):
      return {
        ...state,
        loading: false,
        entities2: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_COURSEBYID):
      return {
        ...state,
        loading: false,
        entity2: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_COURSE):
    case SUCCESS(ACTION_TYPES.UPDATE_COURSE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
        successMessage: action.payload.meta,
      };
    case SUCCESS(ACTION_TYPES.DELETE_COURSE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default courseReducer;

// ACTIONS
export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_COURSE_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntitiesJoin = (id, page, size, sort) => ({
  type: ACTION_TYPES.FETCH_COURSE_REQUEST,
  payload: axios.get(`${apiUrl}/${id}/join_request`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_COURSE,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const getEntityCourseByID = id => ({
  type: ACTION_TYPES.FETCH_COURSEBYID,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const getEntitiesCondition = (condition, page, sort) => ({
  type: ACTION_TYPES.FETCH_COURSE_LIST,
  payload: axios.get(`${apiUrl}/search?q=${condition}`, {
    params: {
      page: undefined || page,
      sort: undefined || sort,
    },
  })
});

export const getSyllabus = id => ({
  type: ACTION_TYPES.FETCH_COURSE_LIST2,
  payload: axios.get(`${apiUrl}/${id}/syllabus`)
});

export const getEntitiesByIDs = condition => ({
  type: ACTION_TYPES.FETCH_COURSE_LIST2,
  payload: axios.get(`${apiUrl}/ids?ids=${condition}`),
});

export const createEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_COURSE,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  return result;
};

export const updateEntity = (entity, id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_COURSE,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  return result;
};

export const ResetCourse = (id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_COURSE,
    payload: axios.post(`${apiUrl}/${id}/reset`),
    meta: { successMessage: `Berhasil reset pelatihan!` },
  });
  dispatch(getEntities(null, null, 'name,asc'));
  return result;
};

export const deleteEntity = (id, sortTable, pagination) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_COURSE,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { successMessage: `Berhasil hapus!` },
  });
  dispatch(getEntities(pagination.current - 1, null, sortTable));
  return result;
};

export const deleteDiscussionCourse = id => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_COURSE,
    payload: axios.delete(`${apiUrl}/${id}/discussion`),
    meta: { successMessage: `Berhasil reset diskusi!` },
  });
  dispatch(getEntities(null, null, 'name,asc'));
  return result;
};

export const transferUserBatch = (courseID, entity, type) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_COURSE,
    payload: axios.post(`${apiUrl}/${courseID}/transfer_participant?type=${type}`, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
